import { defineMessage } from 'services/localization';

export const messages = {
    editingMatrix: defineMessage('editing_matrix'),
    cannotEditAnyField: defineMessage('cannot_edit_any_field'),
    canEditXFields: defineMessage('can_edit_qty_fields'),
};
